export default "__VITE_ASSET__PRvUCX8U__"